import React, { useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { X } from 'lucide-react';

export interface AuthModalProps {
  onClose: () => void;
}

export function AuthModal({ onClose }: AuthModalProps) {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { loading, signIn, signUp } = useAuth();
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    try {
      if (isLogin) {
        await signIn(email, password);
      } else {
        await signUp(email, password);
      }
      onClose();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Authentication failed');
    }
  };

  return (
    <div className="glass-panel p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-bold">
          {isLogin ? 'Sign In' : 'Create Account'}
        </h2>
        <button 
          onClick={onClose}
          className="text-[var(--secondary-text)] hover:text-[var(--primary-text)]"
          disabled={loading}
        >
          <X className="w-6 h-6" />
        </button>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input w-full"
            required
            disabled={loading}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-[var(--secondary-text)] mb-2">
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input w-full"
            required
            disabled={loading}
          />
        </div>

        {error && (
          <div className="text-[var(--danger-color)] text-sm">
            {error}
          </div>
        )}

        <button 
          type="submit" 
          className="btn w-full disabled:opacity-50"
          disabled={loading}
        >
          {loading ? 'Processing...' : (isLogin ? 'Sign In' : 'Create Account')}
        </button>

        <button
          type="button"
          onClick={() => setIsLogin(!isLogin)}
          className="text-[var(--accent-color)] text-sm w-full text-center"
          disabled={loading}
        >
          {isLogin ? 'Need an account? Sign up' : 'Already have an account? Sign in'}
        </button>
      </form>
    </div>
  );
}